import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DeviationDefinition} from '../../../domain/deviation-definition';
import {MatTableDataSource} from '@angular/material/table';

@Component({
    selector: 'app-deviation-definition-table',
    templateUrl: './deviation-definition-table.component.html',
    styleUrls: ['./deviation-definition-table.component.css'],
    standalone: false
})
export class DeviationDefinitionTableComponent {
  @Output() editDefinition: EventEmitter<DeviationDefinition> = new EventEmitter();

  @Input('definitions')
  set definitions(value: DeviationDefinition[]) {
    this._definitions = value;

    this.buildColumnList();

    if (this.dataSource === undefined) {
      this.dataSource = new MatTableDataSource(this._definitions);
    } else {
      this.dataSource.data = this._definitions;
    }
  }

  private _definitions: DeviationDefinition[];

  displayedColumns = [];

  dataSource: MatTableDataSource<DeviationDefinition>;
  headersVisible: any;

  private buildColumnList() {
    const columns = [];

    columns.push('Name', 'Type', 'Context');

    this.displayedColumns = columns;
  }
}
